@if (isInit) {
  <div class="sc-dialog-wrapper" style="max-width: 768px">
    @if (!resultMode) {
      <button
        mat-icon-button
        class="m3-dialog-close-button"
        (click)="abort()"
        [matTooltip]="'close' | translate"
        aria-label="close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <div class="m3-dialog-header">
      <mat-icon class="m3-dialog-icon">psychology_alt</mat-icon>
      @if (!resultMode) {
        <h2 class="m3-dialog-headline">{{ 'video_question' | translate }}</h2>
        <p
          class="m3-dialog-supporting-text mb-0 px-4"
          [innerHTML]="'video_question_set_info' | translate"
        ></p>
        {{
          'video_question_set_answer_amount_hint'
            | translate
              : {
                  questions: questions.length,
                  answers: settings?.min_amount_correct_answers,
                }
        }}
      } @else {
        <h2 class="m3-dialog-headline">
          {{ result?.count_correct }} / {{ result?.count_questions }}
          {{ 'video_question_set_correct' | translate }}
        </h2>
      }
    </div>

    <div
      mat-dialog-content
      style="
        --mat-dialog-content-padding: 0;
        --mat-dialog-with-actions-content-padding: 0 var(--md-sys-size-2);
        --mdc-dialog-supporting-text-color: var(--md-sys-color-on-surface);
      "
    >
      <!-- Sequential questions: no intermediate feedback -->
      @if (!resultMode) {
        <p class="text-center mt-2 mb-0">
          {{ 'video_question_set_progress' | translate }}
          {{ currentIndex + 1 }} / {{ questions.length }}
        </p>
        <div class="grid">
          <exercise-task-module
            [config]="currentQuestion"
            [componentBaseUrl]="questionSetBaseUrl"
            [deferSubmit]="true"
            [onlyOneQuestion]="true"
            [showQuestionNumber]="false"
            (answerCollected)="onAnswerCollected($event)"
            style="--exercise-task-card-background-color: transparent"
          ></exercise-task-module>
        </div>
      } @else {
        <!-- Final summary: which questions were correct / wrong (no correct answer revealed) -->
        <div class="px-4 py-2">
          <p
            class="text-center"
            [ngClass]="{
              'color-success': result?.passed,
              'color-danger': !result?.passed,
            }"
          >
            <mat-icon>{{
              result?.passed ? 'check_circle' : 'cancel'
            }}</mat-icon>
            {{
              (result?.passed
                ? 'video_question_set_passed'
                : 'video_question_set_failed'
              ) | translate
            }}
          </p>

          <table mat-table [dataSource]="dataSource!" class="w-100">
            <ng-container matColumnDef="question">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'question' | translate }}
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.text }}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'Passed' | translate }}?
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-icon
                  [ngClass]="{
                    'color-success': row.is_correct,
                    'color-danger': !row.is_correct,
                  }"
                  >{{ row.is_correct ? 'check' : 'close' }}</mat-icon
                >
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      }
    </div>

    @if (resultMode) {
      <div mat-dialog-actions class="pt-2 flex-justify-content-center">
        @if (result?.passed) {
          <button mat-button (click)="close('nextVideo')">
            <mat-icon>arrow_forward</mat-icon>
            {{ 'Next_lesson' | translate }}
          </button>
        } @else {
          <button mat-button (click)="close('repeatVideo')">
            <mat-icon>replay</mat-icon>
            {{ 'Replay_video' | translate }}
          </button>
        }
      </div>
    }
  </div>
}
